"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NodeDict = void 0;

var the_lodash_1 = __importDefault(require("the-lodash"));

var DnUtils = __importStar(require("./dn-utils"));

var NodeDict =
/** @class */
function () {
  function NodeDict() {
    this._kindResolver = {};
    this._pathResolver = {};
  }

  NodeDict.prototype.setKind = function (key, value) {
    this._kindResolver[key] = value;
  };

  NodeDict.prototype.setPath = function (path, value) {
    var names = path.map(function (x) {
      return x.toString();
    });
    var key = names.join('-');
    this._pathResolver[key] = value;
  };

  NodeDict.prototype.get = function (dnOrParts) {
    var dnParts;

    if (the_lodash_1.default.isString(dnOrParts)) {
      dnParts = DnUtils.parseDn(dnOrParts);
    } else {
      dnParts = dnOrParts;
    }

    var lastPart = the_lodash_1.default.last(dnParts);

    if (!lastPart) {
      console.error("[DiagramDict] invalid dn provided."); // throw new Error("Invalid dn: " + dnOrParts);

      return this._getDefaultValue([]);
    }

    var kind = lastPart.kind;
    {
      var value = this._kindResolver[kind];

      if (value) {
        if (the_lodash_1.default.isString(value)) {
          return value;
        } else {
          var value2 = value(dnParts);

          if (value2) {
            return value2;
          }

          return this._getDefaultValue(dnParts);
        }
      }
    }
    {
      var names = dnParts.map(function (x) {
        return x.kind;
      });
      var key = names.join('-');
      var value = this._pathResolver[key];

      if (value) {
        if (the_lodash_1.default.isString(value)) {
          return value;
        } else {
          var value2 = value(dnParts);

          if (value2) {
            return value2;
          }

          return this._getDefaultValue(dnParts);
        }
      }
    }
    console.error("[DiagramDict] Could not resolve value for: ", dnOrParts);
    return this._getDefaultValue(dnParts);
  };

  NodeDict.prototype._getDefaultValue = function (dn) {
    throw new Error("Could not resolve value for: " + dn);
  };

  return NodeDict;
}();

exports.NodeDict = NodeDict;